import { render, staticRenderFns } from "./FormSendInquiry.vue?vue&type=template&id=f68570b8&scoped=true&"
import script from "./FormSendInquiry.vue?vue&type=script&lang=ts&"
export * from "./FormSendInquiry.vue?vue&type=script&lang=ts&"
import style0 from "./FormSendInquiry.vue?vue&type=style&index=0&id=f68570b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68570b8",
  null
  
)

export default component.exports